module.exports = "//static.hsappstatic.net/ContentUtils/static-1.45892/img/choiceButtons/social-icon-background-shape-square.svg"